import { Component, Inject, Input, OnChanges, OnDestroy, SimpleChange
       } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

import { TemplateConfig, TemplateGroupConfig, TemplatesSettings
       } from 'app/collage-designer/collage-designer-config';
import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { ProductUpgradeService
       } from 'core/product-upgrade/product-upgrade.service';
import { Utils } from 'core/utils';
import { AsyncEventEmitterSubscriber } from 'core/utils/async-event-emitter';
import { ToolboxComponent, } from '../toolbox.component';
import { ToolboxService, } from '../toolbox.service';

@Component({
  selector: 'layout-toolbox',
  templateUrl: './layout-toolbox.component.html',
  styleUrls: [ '../toolbox.component.scss', 'layout-toolbox.component.scss' ],
})
export class LayoutToolboxComponent
    extends ToolboxComponent implements OnChanges, OnDestroy
{
  @Input() public templateGroups: Array<TemplateGroupConfig>;
  @Input() public templatesSettings: TemplatesSettings;
  public templateId: string;
  public templateGroupId: string;

  private designStepService: DesignStepService;
  private templateChangedSubscription:
      AsyncEventEmitterSubscriber<TemplateConfig>;

  constructor(
      mir: MatIconRegistry,
      sanitizer: DomSanitizer,
      @Inject(DesignStepService) designStepService,
      @Inject(ProductUpgradeService) private productUpgradeService:
          ProductUpgradeService,
      @Inject(ToolboxService) toolboxService
  )
  {
    super(mir, sanitizer, toolboxService);
    this.designStepService = designStepService;

    this.loadIcon('layouts');

    this.templateChangedSubscription =
        this.designStepService.templateChanged.subscribe(
          (templateConfig: TemplateConfig) => {
            this.templateId = templateConfig.id;
          });
  }

  public ngOnDestroy(): void
  {
    this.designStepService.templateChanged.unsubscribe(
        this.templateChangedSubscription);
  }

  public async updateSelectedTemplateId(templateId: string): Promise<void>
  {
    await this.designStepService.setTemplateId(templateId);
    this.closeIfSmallOrMediumDevice();
  }

  public async updateSelectedTemplate(
      templateGroupId: string, templateId: string): Promise<void>
  {
    await this.designStepService.setTemplateGroupId(
        templateGroupId, templateId);
    this.closeIfSmallOrMediumDevice();

    await this.productUpgradeService.popUpgradeDialogIfPossible(
        templateGroupId, templateId);
  }

  public closeIfSmallOrMediumDevice(): void
  {
    if (Utils.isSmallDevice() || Utils.isMediumDevice()) {
      this.btnOKClick();
    }
  }

  public ngOnChanges(changes: {[propKey: string]: SimpleChange}): void
  {
    if (changes['templateGroups']) {
      this.templateGroupId =
          String(this.designStepService.getTemplateGroupId());
      this.templateId = this.designStepService.getTemplateId();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/toolboxes/layout-toolbox/layout-toolbox.component.ts